import { render, staticRenderFns } from "./SwitcherLanguages.vue?vue&type=template&id=7a01cc2b&scoped=true&"
import script from "./SwitcherLanguages.vue?vue&type=script&lang=js&"
export * from "./SwitcherLanguages.vue?vue&type=script&lang=js&"
import style0 from "./SwitcherLanguages.vue?vue&type=style&index=0&id=7a01cc2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a01cc2b",
  null
  
)

export default component.exports